import PhotoCred from './PhotoCred';

export default PhotoCred;
